module.exports = __webpack_public_path__ + "img/logo-open-knowledge.3ba4071c.svg";